<template>
  <div style="height: 30vh">
    <div class="title" style="height: 10%">D5 解决方案及实施计划 Counter-measure & Action Plan</div>
    <div style="height: 90%;" class="bad-scroll">
        <table class="table-wrapper" style="height:100%">
          <tbody>
            <tr style="font-size:13px;">
              <td><div v-html="dataStr"></div></td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "fr6d",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["actionPlanStr"]) {
          this.dataStr = val["actionPlanStr"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataStr:'',
      startCharts: null,
    };
  },
  mounted() { },
  methods: {
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy.MM.dd");
      }
      return "";
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.table-wrapper {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #2c7be8;
  border-right: 1px solid #2c7be8;
}

.table-wrapper>thead {
  position: sticky;
  top: 0;
}

.table-wrapper>thead>tr>th {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  font-size: 16px;
}

.table-wrapper>tbody>tr>td {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  font-weight: bold;
  padding: 16px 4px;
  vertical-align: top;
  text-align: left;
  font-size: 16px;
}

.bad-scroll{
    overflow-y:auto
}
.bad-scroll::-webkit-scrollbar {
    width: 4px;
    height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #909090;
}
.bad-scroll::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/a3/component/6d.vue